<template>
  <div class="pageDetail">
    <pageHeader :actNum="1" :bannerShow="false" :title="dataObj.title" />
    <div class="titleDiv">
      <hr class="title-hr" />
      <div class="title">
        <ul class="myul">
          <li
            v-for="(item, index) in dataObj.children"
            :key="index"
            @click="changeTitle(index)"
            :class="titleNum == index ? 'listyact' : 'listy'"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>
    <div class="content">
      <!-- <div class="content-title">{{ dataObj.title }}</div> -->
      <div class="content-body" v-for="(item, index) in dataList" :key="index">
        <div class="content-body-title" v-if="item.type == 'title'">
          {{ item.value }}
        </div>
        <div class="content-body-text" v-if="item.type == 'text'">
          {{ item.value }}
        </div>
        <div class="content-body-text2" v-if="item.type == 'text2'">
          {{ item.value }}
        </div>
        <img
          class="content-body-img"
          v-if="item.type == 'img'"
          :src="getIconPath(item.value)"
        />
      </div>
    </div>
    <footPage />
  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader/index.vue";
import footPage from "@/components/foot/index.vue";
export default {
  name: "pageDetail",
  components: {
    pageHeader,
    footPage,
  },
  props: {
    dataObj: Object,
    actNum:Number
  },
  data() {
    return {
      title: "病案首页数据质量对DRGs应用效果的影响分析",
      dataList: [],
      titleNum: 0,
    };
  },
  methods: {
    // 图片拼接
    getIconPath(iconName) {
      return require(`@/assets/img/product/${iconName}.jpg`);
    },
    changeTitle(index) {
      this.titleNum = index;
      this.dataList = this.dataObj.children[this.titleNum].content;
    },
  },
  mounted() {
    this.changeTitle(this.actNum)
    // this.titleNum = this.actNum
    // this.dataList = this.dataObj.children[this.titleNum].content;
    // console.log(this.dataList);
  },
};
</script>

<style lang="scss" scoped>
.pageDetail {
  .titleDiv {
    position: relative;
    width: 1545px;
    margin: 0 auto;
    .title-hr {
      height: 1px;
      /* // color: #dfdfdf; */
      width: 100%;
      // top: 20px;
      /* // height: 2px; */
      border: none;
      border-top: 1px solid #dfdfdf;
      margin: 0;
      position: absolute;
    }
    .myul {
      /* margin-top: 100px; */
      display: flex;
      position: absolute;
      // top: 20px;
      margin: 0;
      padding: 0;
      // margin-left: 361px;
    }

    .listy {
      margin-right: 50px;
      /* float: left; */
      list-style: none;
      /* padding: 0 20px; */
      cursor: pointer;
      position: relative;
      padding-top: 21px;
      font-size: 15px;
      font-weight: 400;
      color: #999999;
    }

    .listyact {
      margin-right: 50px;
      /* float: left; */
      list-style: none;
      /* padding: 0 20px; */
      cursor: pointer;
      position: relative;
      padding-top: 21px;
      font-size: 15px;
      font-weight: 400;
      color: #333;
      border-top: 1px solid #333;
    }
    .listy::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
      border-top: 1px solid #333;
      transition: 0.25s all linear;
    }

    .listy:hover::before {
      width: 100%;
    }
  }
  .content {
    padding: 40px 518px 175px 518px;
    &-title {
      font-size: 30px;
      text-align: center;
    }
    &-date {
      margin-top: 10px;
      margin-bottom: 28px;
      font-size: 15px;
      text-align: center;
    }
    &-body {
      &-title {
        font-size: 16px;
        color: #333;
        margin-top: 48px;
        text-align: center;
      }
      &-text {
        margin-top: 20px;
        font-size: 15px;
        line-height: 28px;
        color: #666;
        // text-align: center;
      }
      &-text2 {
        // margin-top: 20px;
        // font-size: 14px;
        // line-height: 20px;
        // color: #666;
        margin-top: 20px;
        font-size: 15px;
        line-height: 28px;
        color: #666;
        text-align: center;
      }
      &-img {
        margin-top: 28px;
        // margin-bottom: 28px;
        width: 100%;
      }
    }
  }
}
</style>